// *https://www.registers.service.gov.uk/registers/country/use-the-api*
// import fetch from "cross-fetch";
import akmApi from "../../../../../../apis/akmApi";
import eduprimeApi from "../../../../../../apis/eduprimeApi";
import { CONFIG_AKM } from "../../../../../../config/ConfigAkm";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import { CONFIG_API_BE } from "../../../../../../config";

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default function AutocompleteSearchProvince(props) {
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = React.useState(null);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        if (search !== null) {
            (async () => {
                setOpen(true);
                await eduprimeApi
                    .get(CONFIG_API_BE.API_GET_PROVINSI)
                    .then((data) => {
                        console.info("data", data.data.list_provinsi);
                        const listProvince = data.data.list_provinsi;
                        if (listProvince.length > 0) {
                            setOptions(data.data.list_provinsi);
                        } else {
                            setOptions([]);
                        }
                    })
                    .catch(function (error) {
                        console.error("Error Response Fetch Province", error);
                    });
            })();
        }
        return () => {
            setSearch(null);
        };
    });

    return (
        <Autocomplete
            size="small"
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option.NAMA_PROVINSI === value.NAMA_PROVINSI}
            getOptionLabel={(option) => option.NAMA_PROVINSI}
            options={options}
            loading={loading}
            disableClearable={true}
            onChange={(event, value) => {
                console.info("value prov", value.ID_PROVINSI);
                props.handleChangeProvinsi(value.ID_PROVINSI);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Cari Province"
                    variant="outlined"
                    onChange={(event) => {
                        setSearch(event.target.value);
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}
